/**
 * Antes/depois da estética (F2.4) — o par de fotos por peça que o detailer
 * tira no começo e no fim do serviço, com o mesmo enquadramento.
 *
 * Para a mecânica a foto é prova; na estética ela é o PRODUTO — e o material
 * de divulgação que o detailer hoje monta na mão para o Instagram.
 *
 * Sem dependência nenhuma (só o tipo das peças): o `@mustauto/utils` importa
 * este subcaminho, e quem instala só o próprio workspace (o web-site, no
 * Docker) não tem o `zod` que o índice do pacote puxa.
 */
import type { VehiclePanel } from './vehicle-panels';

export const BEFORE_AFTER_ROLES = ['before', 'after'] as const;
export type BeforeAfterRole = (typeof BEFORE_AFTER_ROLES)[number];

export const BEFORE_AFTER_ROLE_LABELS: Record<BeforeAfterRole, string> = {
  before: 'Antes',
  after: 'Depois',
};

/**
 * As peças que entram no antes/depois, na ordem de volta do carro: as 13
 * pintadas do laudo de espessura (F2.3) mais faróis e lanternas — polimento de
 * farol é serviço comum. Estrutura (longarina, coluna, assoalho) fica de fora:
 * não é estética. Decisão do dono do produto (25/09).
 */
export const BEFORE_AFTER_PANELS = [
  'capo',
  'para_choque_dianteiro',
  'farol_le',
  'farol_ld',
  'para_lama_de',
  'porta_de',
  'porta_te',
  'lateral_te',
  'tampa_traseira',
  'para_choque_traseiro',
  'lanterna_le',
  'lanterna_ld',
  'lateral_td',
  'porta_td',
  'porta_dd',
  'para_lama_dd',
  'teto',
] as const satisfies readonly VehiclePanel[];
export type BeforeAfterPanel = (typeof BEFORE_AFTER_PANELS)[number];

const PANEL_SET: ReadonlySet<string> = new Set(BEFORE_AFTER_PANELS);

export function isBeforeAfterPanel(value: unknown): value is BeforeAfterPanel {
  return typeof value === 'string' && PANEL_SET.has(value);
}
